import { createClient } from './client';

import {
  apiBaseURL,
  endpoints,
} from './config';

const client = createClient(apiBaseURL);

export default class API {
  static encode(data) {
    return client.post(endpoints.encode, data);
  }
}
